import React, { Component } from 'react'
import history from '../../../routes/history';
import connectCommon from '../../common/common-hoc';
import { connect } from 'react-redux'
import * as actionCreatorData from '../../../redux/actions/data-action';
import * as actionCreatorLookup from '../../../redux/actions/lookup-action';
import { isFetchingLookups, getLookup, getLookupErrors, LOOKUP_GENDER, LOOKUP_HISPANIC, LOOKUP_RACE_COUNTRY, LOOKUP_ABORIGINAL } from '../../../redux/actions/lookup-action';

import { Box } from '../../../third-party-components/material-ui';
import { DemoContainer, DemoQuestionText, DemoQuestionDatePicker, DemoQuestionDropDownList, DemoQuestionRadioButtons } from '../common/controls';

import {
    AssessmentContentHeader
} from '../../assessment/common';
import DemoHideabletext from '../common/controls/demo-hideable-text';

const MIN_AGE = 18;
const prevLink = '/Demographic/Ratee';
const nextLink = '/Assessment/Instruction';

const terminationLink = '/Terminate/Demographics';
const defaultNullSelectValue = '--Please Select--';

const errors = {
    genderOtherError: '',
    hispanicOtherError: '',
    raceOtherError: ''
}

class DemographicRater extends Component {
  constructor(props) {
    super(props);

    this.state = { errors };

    this.onChange = this.onChange.bind(this);
    this.handleBack = this.handleBack.bind(this);
    this.handleNext = this.handleNext.bind(this);
  }

componentDidMount() {
  const { getGenderOptions, getHispanicOptions, getAboriginalOptions } = this.props;

  getGenderOptions();
  getHispanicOptions();
  getAboriginalOptions();

  window.history.pushState(null, null, history.location.href);
  window.onpopstate = function(event) {
      history.go(1);
  };
}


handleBack() {
  history.push(prevLink);
}

handleNext() {
  if (this.validateAll()) {
    history.push(nextLink);
  }
}

onChange(e) {
  const {setDemographicsResponse} = this.props;
  const {name, selectedValue, value} = e.target;

  switch (name) {
    case 'raterAge':
    case 'raterKnownStudentYears':
    case 'raterKnownStudentMonths':
      var reg = /^[0-9\b]+$/;
      if ((isNaN(value) || !reg.exec(value)) && value !== "") return;
      break;
  }

  setDemographicsResponse(name, value === defaultNullSelectValue ? null : value);
}

validateAll() {
  return true;
}

validate(name, value) {
  switch (name) {
    case 'raterGenderOtherSP':
      return this.validateGenderOther(value);
    case 'raterHispanicOtherSP':
      return this.validateHispanicOther(value);
    case 'raterRaceOtherSP':
      return this.validateRaceOther(value);
    default:
      return true;
  }
}

validateGenderOther(value) {
  if (this.requireGenderOther()) {
    if (!value || value.trim().length === 0) {
      this.setState({ genderOtherError: 'Please provide a response'})
      return false;
    }
  }

  this.setState({ genderOtherError: ''})
  return true;
}
  
validateHispanicOther(value) {
    if (this.requireHispanicOther()) {
        if (!value || value.trim().length === 0) {
            this.setState({ hispanicOtherError: 'Please provide a response'})
            return false;
        }
    }

    this.setState({ hispanicOtherError: ''})
    return true;
}

validateRaceOther(value) {
    if (this.requireRaceOther()) {
        if (!value || value.trim().length === 0) {
            this.setState({ raceOtherError: 'Please provide a response'})
            return false;
        }
    }   

    this.setState({ raceOtherError: ''})
    return true;
}

requireGenderOther() {
  const { raterGender } = this.props.demographics;

  var required = false;

  if (isNaN(raterGender) && raterGender === defaultNullSelectValue) {
      return false;
  }

  if (raterGender) {
    
      const value =  parseInt(raterGender)
      const option = this.getGenderOption(value);

      if (option) {
        required = option.requireOther;
      }
  }

  if (!required) {
    this.props.demographics.raterGenderOtherSP = null;
  }

  return required;
}

requireHispanic() {
  const { rateeCountry } = this.props.demographics;

  var required = false;

  if (isNaN(rateeCountry) && rateeCountry === defaultNullSelectValue) {
    return false;
  }

  if (rateeCountry) {
    const value = parseInt(rateeCountry)
    
    if (parseInt(value) === 1) {
      required = true;
    } 
  }

  if (!required) {
    this.props.demographics.raterHispanic = null;
  }

  return required;
}

requireHispanicOther() {
  const { raterHispanic } = this.props.demographics;

  var required = false;

  if ((isNaN(raterHispanic) && raterHispanic === defaultNullSelectValue)) {
     return false;
  }

  if (raterHispanic) {
    const value = parseInt(raterHispanic);
    const option = this.getHispanicOption(value);

    required = option && option.requireOther;
  }

  if (!required) {
    this.props.demographics.raterHispanicOtherSP = null;
  }

  return required;
}

requireRace() {
  const { rateeCountry, raterAboriginal } = this.props.demographics;

  var required = false;
  var countryOk = false;
  var aboriginalOk = false;

  if ((isNaN(rateeCountry) && rateeCountry === defaultNullSelectValue)) {
    return false;
  }

  if (rateeCountry) {
    const value = parseInt(rateeCountry);

    if (value !== 3) {
      countryOk = true;
    }
  }

  if (raterAboriginal) {
    const value = parseInt(raterAboriginal);

    if (value === 1) {
      aboriginalOk = true;
    }
  }

  required = countryOk && (parseInt(rateeCountry) === 2 ? aboriginalOk : true);

  if (!required) {
    this.props.demographics.raterRace = null;
  }

  return required;
}

requireRaceOther() {
  const { raterRace } = this.props.demographics;

  var required = false;

  if (isNaN(raterRace) && raterRace === defaultNullSelectValue) {
      return false;
  }

  if (raterRace) {
      const value =  parseInt(raterRace)
      const option = this.getRaceOption(value);

      if (option) {
        required = option.requireOther
      }
  }

  if (!required) {
    this.props.demographics.raterRaceOtherSP = null;
  }

  return required;
}

requireAboriginal() {
  const { rateeCountry } = this.props.demographics;

  var required = false;

  if (isNaN(rateeCountry) && rateeCountry === defaultNullSelectValue) {
    return false;
  }

  if (rateeCountry) {
    const value = parseInt(rateeCountry)
    
    if (parseInt(value) === 2) {
      required = true;
    } 
  }

  if (!required) {
    this.props.demographics.rateeAboriginal = null;
  }

  return required;
}

requireAdditionalInfo() {
    const { rateeCountry } = this.props.demographics;

    var required = false;

    if (rateeCountry == null) {
        return false;
    }

    var value = parseInt(rateeCountry);

    if (value === 3) {
        required = false;
    } else {
        required = true;
    }

    return required;
}

getGenderOption(value) {
  const { genderOptions } = this.props;
  return genderOptions.find((option) => option.value === value);
}

getHispanicOption(value) {
  const { hispanicOptions } = this.props;
  return hispanicOptions.find((option) => option.value === value);
}

getRaceOption(value) {
  const { raceOptions } = this.props;
  return raceOptions.find((option) => option.value === value);
}

getFieldValue(value) {
  var fieldValue = ""

  if (value) {
    if (value != null) {
      fieldValue = value;
    }
  }

  return fieldValue;
}

render() {
  const { 
      demographics, 
      genderOptions, 
      relationshipOptions,
      hispanicOptions,
      raceOptions,
      aboriginalOptions
  } = this.props;

  return (
      <DemoContainer title='Vos Informations' onNextClick={this.handleNext} onBackClick={this.handleBack}>
          <Box display="flex" flexDirection="column" style={{paddingBottom: '20px'}}>
            <div style={{marginBottom: '10px'}}>Veuillez fournir les renseignements démographiques suivants vous concernant.</div>
          </Box>
          <Box style={{width:'100%'}}>
              <Box className='input-group blue'>
                  <DemoQuestionText
                      name="raterFirstName"
                      label="Prénom:"
                      
                      value={this.getFieldValue(demographics['raterFirstName'])}
                      onChange={this.onChange}
                      inputProps={{maxLength:'35'}}
                      validationMessage={this.state.firstNameError}/>
              <DemoQuestionText
                      name="raterLastName"
                      label="Nom de famille:"
                      
                      value={this.getFieldValue(demographics['raterLastName'])}
                      onChange={this.onChange}
                      inputProps={{maxLength:'35'}}
                      validationMessage={this.state.lastNameError}/>
              </Box>
              <Box className="or-box" data-content='OU'/>
              <Box className='input-group blue'>
                  <DemoQuestionText
                      name="raterID"
                      label="Numéro d’identification:"
                      
                      value={this.getFieldValue(demographics['raterID'])}
                      onChange={this.onChange}
                      inputProps={{maxLength:'20'}}
                      validationMessage={this.state.idError}/>
              </Box>
          </Box>
          <Box style={{width:'100%'}}>
            <Box className='input-group' style={{float:'left'}}>
                <DemoQuestionText
                    name="raterClasses"
                    label="Quelle(s) matière(s) enseignez-vous à cet(te) élève?"
                    
                    inputProps={{maxLength:'40'}}
                    value={this.getFieldValue(demographics["raterClasses"])}
                    textField="text"
                    dataItemKey="value"
                    onChange={this.onChange} />
            </Box>
            <Box className='input-group' style={{float:'right'}}>Depuis combien de temps enseignez-vous à cet(te) élève?</Box>
            <Box className='input-group' style={{float:'right'}}>
              <Box>
                <DemoQuestionText
                    name="raterKnownStudentYears"
                    label="(années)"
                    value={this.getFieldValue(demographics["raterKnownStudentYears"])}
                    onChange={this.onChange}
                    inputProps = {{maxLength:'3'}} />
              </Box>
              <Box>
                <DemoQuestionText
                    name="raterKnownStudentMonths"
                    label="(mois)"
                    value={this.getFieldValue(demographics["raterKnownStudentMonths"])}
                    onChange={this.onChange}
                    inputProps = {{maxLength:'3'}}/>
              </Box>
            </Box>
          </Box>
          <Box style={{paddingTop: '1em', marginBottom:'10px'}}>
            <p><b>INFORMATION ADDITIONELLE</b></p>
            Ces questions facultatives vous sont posées aux fins de recherche uniquement. L'administrateur ne pourra pas voir vos réponses.
          </Box>
          <Box style={{width:'100%'}}>
            <div style={{width:'30%'}}>
                  <DemoQuestionText className='input-group'
                      name="raterAge"
                      label="Âge:"
                      value={this.getFieldValue(demographics["raterAge"])}
                      onChange={this.onChange}
                      inputProps = {{maxLength: '3'}}
                      validationMessage={this.state.ageError} />
            </div>
          </Box>
          <Box style={{width:'100%'}}>
                  <DemoQuestionDropDownList
                      name="raterGender"
                      label="Genre:"
                      value={this.getFieldValue(demographics['raterGender'])}
                      data={genderOptions}
                      textField="text"
                      dataItemKey="value"
                      onChange={this.onChange} />
                  <DemoQuestionText
                      name="raterGenderOtherSP"
                      label="Veuillez préciser:"
                      className="demo-text-other"
                      visible={this.requireGenderOther()}
                      value={this.getFieldValue(demographics["raterGenderOtherSP"])}
                      onChange={this.onChange}
                      inputProps = {{maxLength:'30'}}
                      validationMessage={this.state.genderOtherError} />
          </Box>
          <Box style={{width:'100%'}}>
              <DemoQuestionDropDownList
                  name="raterHispanic"
                  label="Êtes-vous d'origine hispanique, latine ou espagnole?"
                  value={this.getFieldValue(demographics["raterHispanic"])}
                  data={hispanicOptions}
                  visible={this.requireHispanic()}
                  textField="text"
                  dataItemKey="value"
                  onChange={this.onChange}
                  validationMessage={this.state.hispanicError} />
              <DemoQuestionDropDownList
                  name="raterAboriginal"
                  label="Êtes-vous Autochtone, c'est-à-dire issu(e) des Premières Nations (Indiens d'Amérique du Nord), Métis ou Inuk (Inuit)?"
                  value={this.getFieldValue(demographics["raterAboriginal"])}
                  data={aboriginalOptions}
                  visible={this.requireAboriginal()}
                  textField="text"
                  dataItemKey="value"
                  onChange={this.onChange}
                  validationMessage={this.state.aboriginalError} />
              <DemoQuestionText
                  name="raterHispanicOtherSP"
                  label="Veuillez préciser:"
                  className="demo-text-other"
                  
                  visible={this.requireHispanicOther()}
                  value={this.getFieldValue(demographics["raterHispanicOtherSP"])}
                  onChange={this.onChange}
                  inputProps = {{maxLength:'30'}}
                  validationMessage={this.state.hispanicOtherError} />
          </Box>
          <Box style={{width:'100%'}}>
              <DemoQuestionDropDownList
                  name="raterRace"
                  label="Ethnicité:"
                  value={this.getFieldValue(demographics["raterRace"])}
                  data={raceOptions}
                  visible={this.requireRace()}
                  textField="text"
                  dataItemKey="value"
                  onChange={this.onChange}
                  validationMessage={this.state.raceError} />
              <DemoQuestionText
                  name="raterRaceOtherSP"
                  label="Veuillez préciser:"
                  className="demo-text-other"
                  
                  visible={this.requireRaceOther()}
                  value={this.getFieldValue(demographics["raterRaceOtherSP"])}
                  onChange={this.onChange}
                  inputProps = {{maxLength:'30'}}
                  validationMessage={this.state.raceOtherError} />
          </Box>
      </DemoContainer>
    )
  } 
}

const mapStateToProps = (state, ownState) => ({
  demographics: state.data.demographics,
  genderOptions: getLookup(state, LOOKUP_GENDER),
  hispanicOptions: getLookup(state, LOOKUP_HISPANIC),
  raceOptions: getLookup(state, LOOKUP_RACE_COUNTRY),
  aboriginalOptions: getLookup(state, LOOKUP_ABORIGINAL),
  optionErrors: getLookupErrors(state, [LOOKUP_GENDER, LOOKUP_HISPANIC, LOOKUP_RACE_COUNTRY, LOOKUP_ABORIGINAL]),
  isFetching: isFetchingLookups(state, [LOOKUP_GENDER, LOOKUP_HISPANIC, LOOKUP_RACE_COUNTRY, LOOKUP_ABORIGINAL])
})

export default connect(mapStateToProps, Object.assign({}, actionCreatorData, actionCreatorLookup))(connectCommon(DemographicRater));